import React from "react"
import { Helmet } from "react-helmet"

const Comscore = () => (
    <Helmet>
        <script>
            {`
                var _comscore = _comscore || []
                _comscore.push( { c1: "2", c2: "18120612" } )
            
                var s = document.createElement( "script" )
                var el = document.getElementsByTagName( "script" )[0]
                s.async = true
                s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/cs/18120612/beacon.js"
                el.parentNode.insertBefore( s, el )
            `}
        </script>
    </Helmet>
)

export default Comscore
